<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0 no-gutter">
        <back-button></back-button>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="provider" isMandatory
            :mandatoryErrorIndicator="providerError"
            :inputLabel="$t('common.routing.provider')" :placeholderValue="$t('common.routing.provider')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <label class>
            {{ $t('common.routing.norm') }}
            <span class="color-red">* </span>
          </label>
          <div class="inputParentFormWriteGroup">
            <select class="form-control inputAccordionForm" v-model="norm">
              <option value="" disabled>Selectionner une norme</option>
              <option v-for="option in normOptions" :value="option">{{option}}</option>
            </select>
          </div>
          <div v-if="normError" class="text-danger" :class="customErrorClass">
            {{ $t('errors.is_mandatory', { mandatoryValue: $t('common.routing.norm').toLowerCase() }) }}
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-end mt-3 no-gutters">
          <b-button v-if="isAddMode" :disable="activateSpinner"
          @click="createConfig" variant="primary">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
          <b-button v-if="isEditMode"  :disable="activateSpinner"
            @click="editConfig" variant="primary">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import backButton from "@/components/common/backButton.vue"
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'RTPNormDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isAddMode () {
      return this.id === '-1'
    },
    isEditMode () {
      return this.id !== '-1'
    }
  },
  data () {
    return {
      activateSpinner: false,
      norm: '',
      normError: false,
      normOptions: ['SRTP', 'HRTP'],
      pageTitle: '',
      provider: '',
      providerError: false
    }
  },
  created () {
    this.pageTitle = this.isAddMode ? this.$i18n.t('common.routing.add_norm') : this.$i18n.t('common.routing.edit_norm')
    if (!this.isAddMode) {
      this.getDetails()
    }
  },
  methods: {
    createConfig () {
      let that = this
      if (!this.provider) {
        // mandatory error
      }
      if (!this.norm) {
        // mandatory error
      }
      this.activateSpinner = true
      this.$engine.routing.member.createNorm({
        norm: this.norm,
        idProvider: this.provider
      })
      .then(resp => {
        loadPage(that, {url: '/routing/norm/list'})
        that.$f7.alert('', that.$i18n.t('common.routing.norm_added'))
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      .finally(() => {
        that.activateSpinner = false
      })
    },
    editConfig () {
      let that = this
      this.$engine.routing.member.updateNorm({
        id: this.id,
        norm: this.norm,
        idProvider: this.provider
      })
      .then(resp => {
        loadPage(that, {url: '/routing/norm/list'})
        that.$f7.alert('', that.$i18n.t('common.routing.norm_edited'))
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      .finally(() => {
        that.activateSpinner = false
      })
    },
    getDetails () {
      let that = this
      this.activateSpinner = true
        this.$engine.routing.member.fetchNorm(this.id)
        .then(resp => {
          if (resp && resp.data && resp.data.Providers && resp.data.Providers.length) {
            let provider = resp.data.Providers[0]
            that.provider = provider.Provider
            that.norm = provider.Norm
          }
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
        .finally(() => {
          that.activateSpinner = false
        })
    }
  }
}

</script>
